var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === _vm.Status.success)?_c('img',{attrs:{"src":_vm.curSrc,"alt":_vm.alt,"title":_vm.title}}):_c('div',{staticClass:"default-image",style:({backgroundImage: ("url(" + _vm.curSrc + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }